import React, { useRef, useEffect } from 'react';

const SineWave = ({ a, b, c, d }) => {
    const canvasRef = useRef(null);
    const phaseRef = useRef(d);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let animationFrameId;

        const resizeCanvas = () => {
            // Set canvas size to match its display size
            const parent = canvas.parentElement;
            if (parent) {
                canvas.width = parent.clientWidth;
                canvas.height = parent.clientHeight;
            } else {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
            }
        };

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        const render = () => {
            phaseRef.current += 0.1; // Animation speed
            const width = canvas.width;
            const height = canvas.height;
            const centerY = height / 2;

            ctx.clearRect(0, 0, width, height);
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(0, 255, 0, 0.8)'; // Green color
            ctx.lineWidth = 2;

            for (let x = 0; x < width; x++) {
                // Formula: f(x) = a + b * sen(c.x + d)
                // a: Vertical shift (pixels)
                // b: Amplitude (pixels)
                // c: Frequency (multiplier for x)
                // d: Phase (animated)
                
                // We center the wave vertically on the canvas
                // Canvas Y is inverted (0 is top), so we subtract the value to make positive 'a' go up
                const y = centerY - (a + b * Math.sin(c * x + phaseRef.current));

                if (x === 0) {
                    ctx.moveTo(x, y);
                } else {
                    ctx.lineTo(x, y);
                }
            }
            ctx.stroke();
            animationFrameId = window.requestAnimationFrame(render);
        };

        render();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            window.cancelAnimationFrame(animationFrameId);
        };
    }, [a, b, c]);

    return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }} />;
};

export default SineWave;
